



















import { ClientAccountsApi } from '@/api/client-accounts';
import { ClientAccount } from '@/shared/clients/client-account';
import { ClientAccountNote } from '@/shared/clients/client-account-note';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

const clientApi = new ClientAccountsApi();

@Component
export default class EditNoteDialog extends Vue {
    @Prop({ required: true }) private visible!: boolean;
    @Prop({ required: true }) private client!: ClientAccount;
    @Prop({ required: true }) private originalNote!: ClientAccountNote;

    private isVisible: boolean = this.visible;
    private isSaving: boolean = false;
    private note: ClientAccountNote = { ...this.originalNote };

    @Watch('visible')
    private onVisibleChanged(visible: boolean): void {
        this.note = { ...this.originalNote };
        this.$validator.errors.clear();
        this.isVisible = visible;
    }

    private async onSave(): Promise<void> {
        const isValid = await this.$validator.validateAll();

        if (!isValid) {
            return;
        }

        this.isSaving = true;

        try {
            await clientApi.updateClientNoteAsync(this.client.id!, { ...this.note });
            this.$emit('ok', { ...this.note });
        } catch (e) {
            if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: 'Could not update client note, please try again.', type: 'is-danger' });
            }
        }

        this.isSaving = false;
    }

    private onCancel(): void {
        this.$emit('cancel');
    }
}
